import service from '@/services/SICUDgpd_est_crd';

export default {
  namespaced: true,

  state: {
    codeVerify: '',
    hour: null,
    numberDocument: null,
    nit: null,
    roomId: null,
  },

  mutations: {
    SET_DATA_RESULT(state, data) {
      state.numberDocument = data.doc_num;
      state.nit = data.ter_nit;
      state.roomId = data.sal_cod;
    },

    SET_CODE_VERIFY(state, code) {
      state.codeVerify = code;
      state.hour = Date.now();
    },

    CLEAR_CODE_VERIFY(state) {
      state.codeVerify = null;
      state.hour = null;
      state.value = {
        picaut_cel: '',
        picaut_mail: '',
        piiaut_num: '',
      };
    },

    SET_NIT_EXTERNAL(state, nit) {
      state.nit = nit;
    },
  },

  actions: {
    /**
     * Petición para obtener labels registrados en Integrity que serán utilizados en una vista.
     */
    async create({ commit, dispatch, rootGetters }, event) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDgpd_est_crd: {
            eeDatos: [rootGetters['auth/state']],
            eegpd_est_crd: [
              {
                crd_cel: event.crd_cel,
                crd_mail: event.crd_mail,
                crd_tip_gst: event.crd_tip_gst,
                crd_otp_ini: event.otpCode,
              },
            ],
          },
        };

        let notification;

        service.post(payload)
          .then((response) => {
            const data = response.data.dsSICUDgpd_est_crd;

            if (data.eeEstados[0].Returnid === 0) {
              const code = data.eegpd_est_crd[0].crd_codigo64;
              commit('SET_DATA_RESULT', data.eegpd_est_crd[0]);

              // Guardamos el código y los valores en el estado
              commit('SET_CODE_VERIFY', code);

              resolve(data.eegpd_est_crd[0]);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },

    async update({ dispatch, rootGetters }, event) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDgpd_est_crd: {
            eeDatos: [rootGetters['auth/state']],
            eegpd_est_crd: [
              {
                doc_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || 0,
                crd_pre: event.crd_pre,
                crd_cuo: event.crd_cuo,
                crd_tip_crd: event.crd_tip_crd?.[0].lis_det_par || event.crd_tip_crd,
              },
            ],
          },
        };

        let notification;

        service.put(payload)
          .then((response) => {
            const data = response.data.dsSICUDgpd_est_crd;

            if (data.eeEstados[0].Returnid === 0) {
              resolve(data.eegpd_est_crd[0]);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },

  getters: {
    state(state) {
      return {
        ...state,
      };
    },
  },
};
